import React from 'react';
import logo from './logo.svg';
import './App.css';
import Gallery from './Gallery/Gallery';

function App() {
  return (
    <div className="App">
      <Gallery></Gallery>
    </div>
  );
}

export default App;
